var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "c-button",
    _vm._b(
      {
        attrs: { disabled: _vm._loading },
        on: {
          click: function ($event) {
            return _vm.handleClick($event)
          },
        },
      },
      "c-button",
      _vm.$attrs,
      false
    ),
    [
      _vm._loading
        ? [
            _c("b-spinner", { staticClass: "mr-2", attrs: { small: "" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.loadingText))]),
          ]
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }